<template>
  <v-card>
  <v-container fluid class="px-0 pt-0">
  <v-card>
  <form ref="form"
  v-model="valid"
  lazy-validation>
      <v-row class="px-2">
      <v-col cols="12" sm="6" md="3">
          <v-menu v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          >
          <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="editedItem.start_dt"
                  label="Fecha de Turno Desde"
                  prepend-icon="mdi-calendar-today"
                  :rules="fechaRule"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
          </template>
          <v-date-picker v-model="editedItem.start_dt" @input="menu = false"></v-date-picker>
          </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-menu v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          >
          <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="editedItem.end_dt"
                  label="Fecha de Turno Hasta"
                  prepend-icon="mdi-calendar-today"
                  :rules="fechaRule"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
          </template>
          <v-date-picker v-model="editedItem.end_dt" @input="menu2 = false"></v-date-picker>
          </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-autocomplete v-model="editedItem.ApiPunto"
          :items="oppoint"
          :item-text="'OpPoint_Description'"
          :item-value="'OpPoint_id'"
          label="Centro"
          multiple
          ></v-autocomplete>
       </v-col>
       <v-col cols="12" sm="6" md="3">
          <v-autocomplete v-model="editedItem.TurningStorageArea"
          :items="TurningStorageArea"
          :item-text="'TurningStorageArea_Desc'"
          :item-value="'TurningStorageArea_Desc'"
          label="Almacen"
          multiple
          ></v-autocomplete>
       </v-col>
       <v-col cols="12" sm="6" md="3">
          <v-btn :disabled="btn" color="primary" @click="submit">Buscar</v-btn>
        </v-col>
      </v-row>
    </form>
    <v-spacer></v-spacer>
    </v-card>
    </v-container>
    <v-container fluid class="px-0">
      <v-card>
       <v-card-title>
         <v-icon x-large>mdi-clipboard-list-outline</v-icon>Planning
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      :items="mvm"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
    <template v-slot:item.action="{ item }">
      <v-tooltip bottom>
       <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          class="mr-2"
          v-bind="attrs"
          v-on="on"
          @click="viw_detail(item)"
        >
          mdi-eye
        </v-icon>
        </template>
        <span>Ver Detalle</span>
        </v-tooltip>
      </template>
    </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>
   <v-card class="py-2 px-2">
      <template>
      <div class="d-flex justify-space-around">
          <v-btn type="button" color="primary" @click="onexport" class="mx-4">Descargar Planning</v-btn>
          <v-btn type="button" color="primary" @click="cargaModificacion">Cargar Modif. Parcial</v-btn>
      </div>
      </template>
   </v-card>
    <v-dialog v-model="dialog_detail" max-width="1000px">
    <v-card>
              <v-card-title>
                <span class="headline">Detalle</span>
              </v-card-title>
  
              <v-card-text>
                <v-container>
                <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.TurningStorageArea_Desc"
                          label="Almacen"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.OpPoint_id"
                          label="Punto"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.VendorPurchaseOrder_Num"
                          label="OC"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.Section_Description"
                          label="Sección"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field :disabled="true" type="text" v-model="this.Supplier_Description"
                          label="Proveedor"  required></v-text-field>
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.RequestProposal_Dt"
                          label="Fecha Emisión"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.Reception_Dt"
                          label="Fecha Entrega"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.Closing_Dt"
                          label="Fecha Cierre"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.CDay_id"
                          label="Fecha Turno"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field :disabled="true" type="text" v-model="this.CHour_Description"
                          label="Hora Turno"  required></v-text-field>
                      </v-col>
                  </v-row>
    <v-data-table
      :headers="headers2"
      :items="tdetalle_vew"
      :search="search2"
      sort-by="ProductBarCode_id"
      class="elevation-1"
    >
    </v-data-table>
                  </v-container>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close2">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_new" max-width="900px">
    <v-stepper v-model="e1" vertical>
           <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
          <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Buscando Pedidos
              <small>Consultando Turnos del {{this.editedItem.start_dt}} hasta {{this.editedItem.end_dt}}</small>
          </v-stepper-step>
          <v-stepper-content step="1">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>
  
          <v-stepper-step :complete="e1 > 2" step="2" :rules="[value => !! step_error2]" :color="step_color2">Buscando Referencias
              <small>Consultando detalle de los Turnos encontrados del {{this.editedItem.start_dt}} hasta {{this.editedItem.end_dt}}</small>
          </v-stepper-step>
          <v-stepper-content step="2">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>
          
      </v-stepper>
    </v-dialog>
    <v-dialog v-model="dialog_carga" max-width="900px">
              <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
              </v-overlay>
              <v-card>
                  <v-card-title>
                      <span class="headline">Carga Modificacion Parcial</span>
                  </v-card-title>
  
                  <v-card-text>
                      <v-file-input
                          show-size
                          counter
                          v-model="file"
                          accept=".xlsx"
                          :loading="loadingCarga"
                          label="Ingrese Archivo"
                      ></v-file-input>
                  </v-card-text>
  
                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="close">Cancelar</v-btn>
                      <v-btn :disabled="loadDisabled || file == null" color="accent" text @click="loadFile">Cargar</v-btn>
                  </v-card-actions>
              </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog_load" max-width="400" persistent>
            <v-card color="blue-grey darken-3" dark>
              <div v-if="!invalidHeaders">
                <v-card-title class="headline">Cantidades Procesadas</v-card-title>
                <v-card-text class="text-h6">Filas omitidas: {{ rowsOmmited }}</v-card-text>
                <v-card-text class="text-h6">Filas con mal formato: {{ rowsBadFormat }}</v-card-text>
                <v-card-text class="text-h6">Filas con monto superior al límite: {{ rowsExceeded }}</v-card-text>
                <v-card-text class="text-h6">Filas Ok: {{ rowsOk }}</v-card-text>
                <div v-if="noRows">
                  <v-card-subtitle>No hay filas para procesar</v-card-subtitle>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                      <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn>
                  </v-card-actions>
                </div>
                <div v-if="!noRows">
                  <div style="display:flex; justify-content:center" v-if="!processComplete">
                    <v-progress-circular model-value="20" indeterminate class="mx-2"></v-progress-circular><span>Aguarde mientras se procesa la solicitud</span>
                  </div>
                  <div style="display:flex; justify-content:center" v-else-if="processComplete">
                    <span>Solicitud procesada.</span>
                  </div>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                      <v-btn color="primary" @click="dialog_load=false" :disabled="!processComplete">Cerrar</v-btn>
                  </v-card-actions>
                </div>
              </div>
              <div v-else-if="invalidHeaders">
                <v-card-subtitle>Las cabeceras del archivo no concuerdan con los esperados.</v-card-subtitle>
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn>
                </v-card-actions>
              </div>
              
            </v-card>
          </v-dialog>
  
        </v-card>
  </template>
  
  <script>
  import axios from 'axios'
  //import Vue from "vue";
  //import JsonExcel from "vue-json-excel";
  import XLSX from 'xlsx';
   
  //Vue.component("downloadExcel", JsonExcel);
  
  export default {
    data: () => ({
      search: '',
      search2: '',
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      dialog: false,
      dialog_pass: false,
      dialog_new: false,
      dialog_detail: false,
      dialog_carga: false,
      dialog_load: false,
      valid: true,
      menu: false,
      menu2: false,
      e1: 0,
      btn: false,
      msj_proceso:'',
      progressBar1: false,
      progressBar: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      TurningStorageArea_Desc:'',
      OpPoint_id: '',
      Supplier_Description:'',
      VendorPurchaseOrder_Num:'',
      Section_Description:'',
      RequestProposal_Dt: '',
      Reception_Dt: '',
      Closing_Dt:'',
      Comment_Txt:'',
      CDay_id:'',
      CHour_Description:'',
      file: null,
      loadingCarga: false,
      loadDisabled: false,
      rowsOmmited: 0,
      rowsBadFormat: 0, 
      rowsExceeded: 0,
      rowsOk: 0,
      invalidHeaders: false,
      processComplete: false,
      noRows: false,
      headers: [
        { text: 'Actions', value: 'action', sortable: false },      
        { text: 'ID Almacen', value: 'TurningStorageArea_id' },
        { text: 'Almacen', value: 'TurningStorageArea_Desc' },
        { text: 'Punto', value: 'OpPoint_id' },
        { text: 'OC', value: 'VendorPurchaseOrder_Num' },
        { text: 'Prov', value: 'Supplier_id' },
        { text: 'R Social', value: 'Supplier_Description' },
        { text: 'Seccion', value: 'Section_Description'},
        { text: 'Fecha Emisión', value: 'RequestProposal_Dt'},
        { text: 'Fecha Entrega', value: 'Reception_Dt' },
        { text: 'Fecha Cierre', value: 'Closing_Dt' },
        { text: 'Observación', value: 'Comment_Txt' },
        { text: 'Fecha de turno', value: 'CDay_id' },
        { text: 'Hora De Turno', value: 'CHour_Description' },
        { text: 'Bultos pedidos', value: 'qty_bu'},
        { text: 'Pallets Pedidos', value: 'qty_pa'},
        { text: 'Cantidad de Referencias', value: 'qty_line'}
      ],
      headers2: [
        { text: 'Ean', value: 'ProductBarCode_id' },
        { text: 'Desc', value: 'ProductBarCode_Description' },
        { text: 'Med', value: 'MeasureUnit_id' },
        { text: 'PCB', value: 'ProductPack_Qty' },
        { text: 'Btos x pallet', value: 'Pallet_Qty' },
        { text: 'Bul Ped', value: 'RequestPack_Qty'},
        { text: 'Pallets', value: 'RequestPallet_Qty'},
        { text: 'Tipo de frío', value: 'ColdType_Desc' }
      ],
      mvm: [],
      tdetalle: [],
      oppoint: [{ OpPoint_id: '', OpPoint_Description: '-Todos' }],
      TurningStorageArea: [{ TurningStorageArea_id: '', TurningStorageArea_Desc: '-Todos' }],
      tdetalle_vew: [],
      ApiUserSupplier:[],
      editedIndex: -1,
      editedItem: {
        start_dt: new Date().toISOString().substr(0, 10),
        end_dt: new Date().toISOString().substr(0, 10),
        ApiPunto: '',
        TurningStorageArea: [ '-Todos' ]
      },
      defaultItem: {
        start_dt: new Date().toISOString().substr(0, 10),
        end_dt: new Date().toISOString().substr(0, 10),
        ApiPunto: '',
        TurningStorageArea: ['-Todos' ]
      },
      fechaRule: [
          v => !!v || 'Fecha es requerida'
      ],
      puntoRules: [
          v => !!v || 'Centro es Requerida',
          v => (v && v != -1.0) || 'Centro no Valida'
      ],
      TurningStorageAreaRules: [
          v => !!v || 'Almacen es Requerido',
          v => (v && v != -1.0) || 'Almacen no Valido'
      ],
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
  
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
  
    created () {
      this.initialize()
    },
  
    methods: {
      initialize () {
        this.overlay = true
        axios.post(this.api_tool_url + '/get_ApiUserSupplier', {ApiUser_id:this.$store.state.ApiUser_id}, this.config)
          .then(response => { 
              response.data.ResultRows.forEach(info => {
              this.ApiUserSupplier.push(info.MotherSupplier_Desc)
              })
          })
          .catch(error => {
            this.ApiUserSupplier = []
            alert(error.response.data.message)
          }),
  
          axios.post(this.api_tool_url + '/get_oppoint_P', {}, this.config)
          .then(response => {
              this.oppoint = response.data.ResultRows
              this.oppoint.push({ OpPoint_id: '', OpPoint_Description: '-Todos' })
          })
          .catch(error => {
            this.oppoint = []
            alert(error.response.data.message)
          }),
  
          axios.post(this.api_tool_url + '/get_turningstoragearea2', {}, this.config)
          .then(response => {
              this.TurningStorageArea = response.data.ResultRows
              this.TurningStorageArea.push({ TurningStorageArea_id: '', TurningStorageArea_Desc: '-Todos' })
              this.overlay = false
          })
          .catch(error => {
            this.TurningStorageArea = []
            alert(error.response.data.message)
          })
      },
      viw_detail(item){
        const index = this.mvm.indexOf(item)
        let tmpmvm = item
        this.dialog_detail=true
        this.progressBar1=true
        this.TurningStorageArea_Desc = tmpmvm.TurningStorageArea_Desc
        this.OpPoint_id = tmpmvm.OpPoint_id
        this.Supplier_Description = tmpmvm.Supplier_Description
        this.VendorPurchaseOrder_Num = tmpmvm.VendorPurchaseOrder_Num
        this.Section_Description = tmpmvm.Section_Description
        this.RequestProposal_Dt = tmpmvm.RequestProposal_Dt
        this.Reception_Dt = tmpmvm.Reception_Dt
        this.Closing_Dt = tmpmvm.Closing_Dt
        this.Comment_Txt = tmpmvm.Comment_Txt
        this.CDay_id = tmpmvm.CDay_id
        this.CHour_Description = tmpmvm.CHour_Description
        this.tdetalle_vew=[]
        
        this.tdetalle_vew = this.tdetalle.filter(function(item) {
          return item.RequestProposal_id == tmpmvm.RequestProposal_id
        })
      },
      submit () {
        this.btn = true
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1= true
        this.step_error2= true
        this.step_error3= true
        this.step_color1="primary",
        this.step_color2="primary",
        this.step_color3="primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        let filter = null
        filter = {start_dt : this.editedItem.start_dt, end_dt: this.editedItem.end_dt, ApiPunto:this.editedItem.ApiPunto,TurningStorageArea:this.editedItem.TurningStorageArea, Supplier:this.ApiUserSupplier, RequestProposal_Dt:""}
        axios.post(this.api_tool_url + '/get_planning',filter, this.config)
            .then(response => {
              
              if(response.data.ResultRows.length >= 1)
              {
                  this.mvm = response.data.ResultRows
                  this.e1 = 2
                  this.step_color1 = "#008000"
                  this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                  axios.post(this.api_tool_url + '/get_planning_detail', filter, this.config)
                  .then(response => {
                      if(response.data.ResultRows.length >= 1)
                      {
                          this.e1 = 3
                          this.step_color2 = "#008000"
                          this.tdetalle = response.data.ResultRows
                      }
                      else{
                          this.progressBar = false
                          this.msj_proceso = "No se encontro detalle."
                          this.step_error2 = false
                          this.step_error3 = false
                      }
                  })
                  .catch(error => {
                      this.td = []
                      this.btn = false
                      this.step_error2 = false
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                  })
              }
              else{
                  this.progressBar = false
                  this.msj_proceso = "No se encontraron turnos."
                  this.step_error1 = false
                  this.step_error2 = false
                  this.step_error3 = false
              }
              this.btn = false
            })
            .catch(error => {
              this.mvm = []
              this.btn = false
              this.step_error1 = false
              this.progressBar = false
              this.msj_proceso = error.response.data.message
            })
      },
  
      close () {
        this.dialog_new = false
        this.dialog_carga = false
      },
      close2 () {
        this.dialog_detail= false
      },
  
      cargaModificacion () {
        console.log("carga modificacion parcial")
        this.dialog_carga = true
        this.file = null
        this.loadingCarga = false
        this.loadDisabled = false
      },
  
      loadFile(){
          this.invalidHeaders = false
          this.processComplete = false
          this.dialog_load = false
          this.overlay = true
          if(this.file != null)
          {
              let data = []
              const reader = new FileReader();
              reader.onload = (e) => {
                /* Parseo data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const ws = wb.Sheets['Detalle'];
                /* Convertir a array de arrays */
                data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                
                /*Filtro filas vacías*/
                data = data.filter(subArr => subArr.length > 0)
  
                /*Validacion de headers*/
                let headers = data[0]
                function arraysEqual(a1,a2) {
                  return JSON.stringify(a1)==JSON.stringify(a2);
                }
  
                /*Valores de archivo*/
                const header_d_f = ['Almacen Id','Almacen','Punto','OC','Prov','R Social','Seccion','Estado','F Ped','F Vto','F Rec','Observacion','Ean','Desc','Med','PCB','Btos x pallet','Bultos a Modificar','Bul Ped ultimo valor', 'Bul Ped valor tabla','Pallets','Fecha Turno','Hora Turno','Tipo de frío', 'Marca Id', 'Marca Descripcion'];
         
                if(arraysEqual(headers, header_d_f)){
  
                  let idxBulModif = headers.indexOf('Bultos a Modificar')
                  let idxBulOrig = headers.indexOf('Bul Ped valor tabla')
                  let idxSection = headers.indexOf('Seccion')
                  let rowsTotal = data.filter((row, index) => index !== 0);
  
                  let idxHeaders = []
                  idxHeaders.push(headers.indexOf('Almacen Id'))
                  idxHeaders.push(headers.indexOf('Punto'))
                  idxHeaders.push(headers.indexOf('OC'))
                  idxHeaders.push(headers.indexOf('Prov'))
                  idxHeaders.push(headers.indexOf('Ean'))
                  idxHeaders.push(headers.indexOf('Bultos a Modificar'))
  
                  let cantOmitidos = 0
                  let cantFormatoError = 0
                  let cantExcedidos = 0
                  let cantOk = 0
                  let regExp = /[a-zA-Z]/g;
                  let rowsComplete = []
                  rowsTotal.map((row)=> {
                    if(row[idxBulModif] !== undefined && !(regExp.test(row[idxBulModif])) ){
                      if(row[idxSection] === 'CARNICERIA'){
                        rowsComplete.push(row)
                      }else if(row[idxBulModif] > row[idxBulOrig]){
                        cantExcedidos +=1
                      }else{
                        rowsComplete.push(row)
                      }
                    }else if(row[idxBulModif] === undefined){
                      cantOmitidos +=1
                    }else{
                      cantFormatoError += 1
                    }
                  })
  
                  cantOk = rowsComplete.length
                  let newRow = []
                  let rows = []
                  
                  rowsComplete.map((row)=> {
                    newRow = []
                    idxHeaders.map((idx)=> {
                      if(idx == headers.indexOf('Ean')){
                        let eanStr = String(row[idx]).trim() //Quitar los espacios en blanco para los strings.
                        if(eanStr.startsWith('0')){
                          newRow.push(eanStr) // Ean que tiene 0 por delante
                        }else{
                          let eanStrWCero = eanStr.padStart(14, '0')
                          // console.log('ean: ' + eanStr)
                          // console.log('ean con ceros: ' + eanStrWCero)
                          newRow.push(eanStrWCero)  // Ean que tiene 0 por delante
                        }
                      }else{
                        newRow.push(row[idx])
                      }
                    })
                    rows.push(newRow)
                  })
  
                  this.rowsOmmited = cantOmitidos
                  this.rowsBadFormat = cantFormatoError
                  this.rowsExceeded = cantExcedidos
                  this.rowsOk = cantOk
                  this.dialog_load = true
  
                  let filter = {
                    file:rows,
                    email: this.$store.state.ApiUser_EMail,
                    user: sessionStorage.getItem('ApiUser_id'),
                    type: 'Prov'
                  }
                  
                  if(rows.length > 0){
                    axios.post(this.api_tool_url + '/fileUpload_PartialModif',filter , this.config)
                    .then(response => {
                      console.log(response.data.ResultRows)
                      if(response.data.status === "OK"){
                        this.processComplete = true
                        this.loadingCarga = false
                        this.overlay = false
                        setTimeout(this.close, 5000)
                      }
                    })
                    .catch(error => {
                        if(error.code == 502){
                          this.processComplete = true
                          this.loadingCarga = false
                          this.overlay = false
                          setTimeout(this.close, 5000)
                        }else{
                          let errorMessage = error.response 
                                && error.response.data 
                                && error.response.data.message 
                                ? error.response.data.message
                                : error.toString()
                          console.log(errorMessage)
                          this.processComplete = true
                          this.loadingCarga = false
                          this.overlay = false
                          setTimeout(this.close, 5000)
                        }
                    })
                  }else{
                    this.processComplete = true
                    this.noRows = true
                    this.overlay = false
                  }
                }else{
                  this.dialog_load = true
                  this.invalidHeaders = true
                  this.overlay = false
                }
              };
  
              reader.readAsBinaryString(this.file);
          }
          else {
              alert("Debe ingresar un archivo")
              this.overlay = false
          }
        },
  
      onexport () { // On Click Excel download button
      
        // export json to Worksheet of Excel
        // only array possible
        const header_r_f = ['Almacen Id','Almacen','Punto','OC','Prov','R Social','Seccion','Fecha Emisión','Fecha Cierre','Observación','Fecha de turno','Hora De Turno','Bultos pedidos','Pallets Pedidos','Cantidad de Referencias'];
        const header_r = ['TurningStorageArea_id','TurningStorageArea_Desc','OpPoint_id','VendorPurchaseOrder_Num','Supplier_id','Supplier_Description','Section_Description','RequestProposal_Dt','Closing_Dt','Comment_Txt','CDay_id','CHour_Description','qty_bu','qty_pa','qty_line'];
        var resumenWS = XLSX.utils.json_to_sheet(this.mvm, {header: header_r}) 
      
        const header_d_f = ['Almacen Id','Almacen','Punto','OC','Prov','R Social','Seccion','Estado','F Ped','F Vto','F Rec','Observacion','Ean','Desc','Med','PCB','Btos x pallet','Bultos a Modificar','Bul Ped ultimo valor', 'Bul Ped valor tabla','Pallets','Fecha Turno','Hora Turno','Tipo de frío', 'Marca Id', 'Marca Descripcion'];
        const header_d = ['TurningStorageArea_id','TurningStorageArea_Desc','OpPoint_id','VendorPurchaseOrder_Num','Supplier_id','Supplier_Description','Section_Description','RequestProposalStatus_Desc','RequestProposal_Dt','Closing_Dt','F_RE','Comment_Txt','ProductBarCode_id','ProductBarCode_Description','MeasureUnit_id','ProductPack_Qty','Pallet_Qty','NewRequestLayer_Qty','RequestPack_Qty', 'RequestPack_QtyOrig','RequestPallet_Qty', 'CDay_id','CHour_Description','ColdType_Desc', 'TradeMarkType_id', 'TradeMarkType_Description'];
        var detalleWS = XLSX.utils.json_to_sheet(this.tdetalle, {header: header_d}) 
  
        var range = XLSX.utils.decode_range(resumenWS['!ref']);
        for(var C = range.s.c; C <= range.e.c; ++C) {
          var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
          resumenWS[colum].v = header_r_f[C];
        }
  
        range.e['c'] = header_r_f.length - 1;
        resumenWS['!ref'] = XLSX.utils.encode_range(range);
  
        var range = XLSX.utils.decode_range(detalleWS['!ref']);
        for(var C = range.s.c; C <= range.e.c; ++C) {
          var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
          detalleWS[colum].v = header_d_f[C];
        }
  
        range.e['c'] = header_d_f.length - 1;
        detalleWS['!ref'] = XLSX.utils.encode_range(range);
  
        // A workbook is the name given to an Excel file
        var wb = XLSX.utils.book_new() // make Workbook of Excel
  
        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        XLSX.utils.book_append_sheet(wb, resumenWS, 'Resumen') // sheetAName is name of Worksheet
        XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
        
        var file='Planning_desde_'+this.editedItem.start_dt+'_hasta_'+this.editedItem.end_dt+'.xlsx';
  
        // export Excel file
        XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/PlanningProvGrid.vue